import {Dialog} from '@headlessui/react';
import {ExclamationTriangleIcon} from '@heroicons/react/24/outline';
import {Button} from '../../components/Button';
import config from '../../config';

export interface UsernameChangeWarningModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  currentUsername: string;
  newUsername: string;
}

export default function UsernameChangeWarningModal(props: UsernameChangeWarningModalProps) {
  const exampleSlug = 'my-amazing-trip';
  const oldUrl = `${config.media.host}/trip/${props.currentUsername}/${exampleSlug}`;
  const newUrl = `${config.media.host}/trip/${props.newUsername}/${exampleSlug}`;

  return (
    <Dialog open={props.open} onClose={props.onCancel} className="relative z-10">
      {/* DialogBackdrop */}
      <div className="fixed inset-0 bg-neutral-dark/75 transition-opacity" aria-hidden="true"></div>

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <Dialog.Panel
            className="relative transform overflow-hidden rounded-lg bg-surface px-4 pt-5 pb-4 text-left
            shadow-xl sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
          >
            <div>
              <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-warning-subtle">
                <ExclamationTriangleIcon aria-hidden="true" className="size-6 text-warning" />
              </div>
              <div className="mt-3 text-center sm:mt-5">
                <Dialog.Title as="h3" className="text-base  text-main">
                  Change Username?
                </Dialog.Title>
                <div className="mt-3 space-y-3 text-left">
                  <p className="text-sm text-muted">
                    Your username is part of the URL for <strong>public trips</strong>. Old links
                    will stop working.
                  </p>

                  <div className="bg-subtle rounded-lg p-3 space-y-2">
                    <div>
                      <div className="text-xs  text-muted mb-1">Old Link</div>
                      <code className="text-xs text-main break-all block bg-canvas px-2 py-1 rounded">
                        {oldUrl}
                      </code>
                    </div>

                    <div className="flex justify-center">
                      <svg
                        className="h-4 w-4 text-muted"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 14l-7 7m0 0l-7-7m7 7V3"
                        />
                      </svg>
                    </div>

                    <div>
                      <div className="text-xs  text-brand mb-1">New Link</div>
                      <code className="text-xs text-main break-all block bg-canvas px-2 py-1 rounded">
                        {newUrl}
                      </code>
                    </div>
                  </div>

                  <div className="text-xs text-muted bg-canvas rounded p-2">
                    ℹ️ Link-shared and private trips are not affected.
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-5 sm:mt-6 flex gap-3">
              <Button variant="secondary" size="md" onClick={props.onCancel} className="flex-1">
                Cancel
              </Button>
              <Button variant="primary" size="md" onClick={props.onConfirm} className="flex-1">
                I Understand, Change Username
              </Button>
            </div>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
}
